import React from 'react';
import cn from 'classnames';

import type { Step as StepType } from '../../types';
import { TEST_ID_TOPBAR_STEPPER_STEP } from './constants';
import styles from './topbarStepper.module.css';

type Props = {
  className?: string;
  currentStep: string;
  onClickStep: (newStep: string) => void;
  steps: StepType[];
};

const TopbarStepper = ({
  className = '',
  currentStep,
  onClickStep,
  steps,
}: Props) => (
  <div className={cn(styles.steps, className)}>
    {steps.map((step) => {
      const active = currentStep === step.id;
      const handleClick = () => {
        onClickStep(step.id);
      };

      return (
        <button
          type="button"
          className={cn(styles.step, { [styles.activeStep]: active })}
          data-testid={TEST_ID_TOPBAR_STEPPER_STEP}
          key={step.id}
          onClick={active ? undefined : handleClick}
        >
          <p className={cn(styles.text, { [styles.activeText]: active })}>
            {step.title}
          </p>
        </button>
      );
    })}
  </div>
);

export default TopbarStepper;
